import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useRef, useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useGenerateId, createInputHandler } from '@lendi-jam/atoms';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { tracking } from '@lendi-jam/tracking';
import getColour from '@lendi-ui/commons/colours';
import Grid from '@lendi-ui/grid';
import Error$1 from '@lendi-ui/icon/Error';
import { Input } from '@lendi-ui/text-input';
import { AnchorButton, Button } from '@lendi/ui/Button';
import { Text } from '@lendi/ui/Typography';
import numeral from 'numeral';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Alert from '@lendi-ui/alert';
import { gte } from '@lendi-ui/breakpoint';
import { fg } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { Select } from '@lendi-ui/dropdown';
import { mb, my, p, mx, px, pr, mt } from '@lendi-ui/spacing';
import { Heading, Body } from '@lendi-ui/typography';
import styled from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12, _templateObject13;
var StyledAlert = styled(Alert)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n"])), mb('md'));
var Wrapper$1 = styled(Container)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  ", "\n"])), my('md'));
var Calculator = styled.form(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  background-color: #f8f8f8;\n  border-radius: 5px;\n  ", "\n"])), p({
  lg: 'lg',
  xs: 'md'
}));
var Title = styled(Heading)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  ", "\n"])), mb('md'));
var StyledHeading$1 = styled(Heading)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: block;\n\n  small {\n    font-size: 18px;\n  }\n"])));
var StyledUnit = styled(Grid.Unit)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  row-gap: 6px;\n\n  &:last-child {\n    ", "\n  }\n\n  & > div {\n    width: 100%;\n  }\n"])), mb('md'), mb('nil'));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var StyledSelect = styled(Select)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  div {\n    ", "\n  }\n"])), fg('shade.500'));
var StyledButtonWrapper = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n"])), mx('auto'), gte('lg')(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n    max-width: 36%;\n  "]))));
var InputAfter = styled(Body)(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  font-weight: 100;\n  ", "\n  ", "\n"])), fg('shade.500'), px('xxs'));
var InputBefore = styled(InputAfter)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  ", "\n"])), pr('xxxs'));
var ResultsWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  border: 1px solid #e3e3e3;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  box-sizing: border-box;\n"])), p({
  lg: 'lg',
  xs: 'md'
}));
var Summary = styled(Body)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", "\n"])), my('xxs'));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var StyledHeading = styled(Heading)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  strong {\n    margin-right: 4px;\n  }\n\n  small {\n    font-size: 14px;\n    display: inline-block;\n\n    ", ";\n  }\n"])), mt('md'), gte('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]))));
var Wrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  color: white;\n  z-index: 1;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: none;\n  ", "\n  ", "\n\n  ", " {\n    height: 100%;\n  }\n\n  a {\n    align-self: flex-end;\n  }\n\n  ", " {\n    ", "\n  }\n"])), function () {
  return getColour('fill', 'contrast');
}, p({
  lg: 'lg',
  xs: 'md'
}), mt('md'), Grid, Body, mt('xxxs'));
var StyledGrid = styled(Grid)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var SeperatorContainer = styled(Grid.Unit)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), gte('lg')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))));
var Seperator = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: white;\n  box-sizing: border-box;\n  height: 1px;\n  margin: 28px auto;\n  padding: 0;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), gte('lg')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    width: unset;\n    margin: 0;\n    height: unset;\n  "]))), gte('lg')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-left: -1px;\n    width: 1px;\n    min-height: 100%;\n  "]))));
var FlexUnit = styled(Grid.Unit)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", " {\n    flex-basis: 100%;\n  }\n"])), Heading);
var NextSteps = styled(FlexUnit)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: start;\n  flex-wrap: nowrap;\n  flex-direction: column;\n  row-gap: 32px;\n  ", " {\n    flex-basis: max-content;\n  }\n"])), Heading);

var NEED_TO_PAY = 'Will you need to pay LMI?';
var GOOD_NEWS = 'Good news!';
var TALK_TO_SPECIALIST = 'Talk to a Home Loan Specialist';
var ResultsPanel = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var lvr = _ref.lvr,
    lmi = _ref.lmi,
    buttonLink = _ref.buttonLink,
    buttonText = _ref.buttonText,
    resultBody = _ref.resultBody,
    resultHeading = _ref.resultHeading;
  var title = GOOD_NEWS;
  if (lvr > 0.8) title = NEED_TO_PAY;
  if (lvr > 0.95) title = TALK_TO_SPECIALIST;
  var lvrPercentage = lvr * 100;
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });
  return /*#__PURE__*/jsx(Wrapper, {
    ref: forwardedRef,
    children: /*#__PURE__*/jsxs(StyledGrid, {
      gutter: "xxxl",
      children: [/*#__PURE__*/jsx(Grid.Unit, {
        size: {
          lg: 2 / 3,
          sm: 1,
          md: 1 / 2
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(FlexUnit, {
            size: 1,
            children: [/*#__PURE__*/jsx(Heading, {
              size: "md",
              children: title
            }), lvr <= 0.8 && /*#__PURE__*/jsx(Body, {
              size: "sm",
              children: "It looks like you won\u2019t need to pay any LMI since you're borrowing under 80% of the purchase price."
            }), lmi && /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsxs(StyledHeading, {
                size: {
                  sm: 'xl',
                  xs: 'lg'
                },
                children: [/*#__PURE__*/jsxs("small", {
                  children: ["You might need to pay ", /*#__PURE__*/jsx("strong", {
                    children: "LMI"
                  }), "of"]
                }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("strong", {
                  children: formatter.format(lmi[0])
                }), " ", /*#__PURE__*/jsx("small", {
                  children: "to"
                }), ' ', /*#__PURE__*/jsx("strong", {
                  children: formatter.format(lmi[1])
                })]
              }), /*#__PURE__*/jsx(Body, {
                size: "sm",
                children: /*#__PURE__*/jsxs("small", {
                  children: ["Since you're borrowing over 80% of the purchase price.", /*#__PURE__*/jsx("br", {}), "You can usually pay this off monthly on top of your home loan repayments."]
                })
              })]
            }), /*#__PURE__*/jsxs(StyledHeading, {
              size: {
                sm: 'xl',
                xs: 'lg'
              },
              children: [/*#__PURE__*/jsxs("small", {
                children: ["Your ", /*#__PURE__*/jsx("strong", {
                  children: "LVR"
                }), "is"]
              }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsxs("strong", {
                children: [lvrPercentage.toFixed(2), "%"]
              })]
            }), /*#__PURE__*/jsx(Body, {
              size: "sm",
              children: /*#__PURE__*/jsx("small", {
                children: "LMI is required when borrowing more than 80% of the property purchase price."
              })
            })]
          })
        })
      }), /*#__PURE__*/jsx(SeperatorContainer, {
        size: {
          lg: 0,
          md: 1
        },
        children: /*#__PURE__*/jsx(Seperator, {})
      }), /*#__PURE__*/jsx(Grid.Unit, {
        size: {
          lg: 1 / 3,
          md: 1
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(NextSteps, {
            size: 1,
            children: [/*#__PURE__*/jsx(Heading, {
              size: "sm",
              children: resultHeading
            }), /*#__PURE__*/jsx(Body, {
              size: "sm",
              children: resultBody
            }), buttonText && buttonLink && /*#__PURE__*/jsx(AnchorButton, {
              width: "100%",
              variant: "primary",
              isInverse: true,
              size: "md",
              href: buttonLink,
              children: buttonText
            })]
          })
        })
      })]
    })
  });
});

var items = [{
  value: 'VIC',
  label: 'Victoria'
}, {
  value: 'NSW',
  label: 'New South Wales'
}, {
  value: 'QLD',
  label: 'Queensland'
}, {
  value: 'WA',
  label: 'Western Australia'
}, {
  value: 'SA',
  label: 'South Australia'
}, {
  value: 'TAS',
  label: 'Tasmania'
}, {
  value: 'ACT',
  label: 'Australian Capital Territory'
}, {
  value: 'NT',
  label: 'Northern Territory'
}];
var DEFAULT_VALUES = {
  propertyPrice: 1000000,
  deposit: 100000,
  state: 'NSW'
};
var MAXIMUM_VALUES = {
  propertyPrice: 999999999,
  deposit: 999999999
};
var schema = yup.object().shape({
  propertyPrice: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Property value must be greater than 0',
    test: function test(propertyPrice) {
      return propertyPrice > 0;
    }
  }),
  deposit: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Deposit amount must be greater than 0',
    test: function test(deposit) {
      return deposit >= 0;
    }
  }).test({
    name: 'max',
    message: 'Your deposit amount cannot be more than the property value.',
    test: function test(value) {
      return value <= this.parent.propertyPrice;
    }
  })
});
var calculateLoanAmount = function calculateLoanAmount(deposit, propertyPrice) {
  return propertyPrice - deposit;
};
var calculateLvrRate = function calculateLvrRate(loanAmount, propertyPrice) {
  return loanAmount / propertyPrice;
};
var LmiCalculator = function LmiCalculator(_ref) {
  var buttonText = _ref.buttonText,
    buttonLink = _ref.buttonLink,
    calculatorHeading = _ref.calculatorHeading,
    resultBody = _ref.resultBody,
    resultHeading = _ref.resultHeading,
    disclaimer = _ref.disclaimer;
  var _useState = useState(items[1]),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var resultElement = useRef(null);
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    results = _useState6[0],
    setResults = _useState6[1];
  var generateId = useGenerateId();
  var _useForm = useForm({
      resolver: yupResolver(schema),
      reValidateMode: 'onChange',
      mode: 'onChange',
      defaultValues: DEFAULT_VALUES
    }),
    errors = _useForm.errors,
    handleSubmit = _useForm.handleSubmit,
    register = _useForm.register,
    reset = _useForm.reset,
    trigger = _useForm.trigger,
    _useForm$formState = _useForm.formState,
    isValid = _useForm$formState.isValid,
    isDirty = _useForm$formState.isDirty,
    isSubmitted = _useForm$formState.isSubmitted;
  var propertyPriceHandler = createInputHandler(MAXIMUM_VALUES.propertyPrice, function () {
    return trigger('propertyPrice');
  });
  var depositHandler = createInputHandler(MAXIMUM_VALUES.deposit, function () {
    return trigger('deposit');
  });
  var disableCalculateButton = useMemo(function () {
    var hasChanged = (results === null || results === void 0 ? void 0 : results.state) !== state.value || isDirty || !isSubmitted;
    return isValid && hasChanged;
  }, [isSubmitted, isValid, isDirty, state, results]);
  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref2$propertyPrice, propertyPrice, deposit, api, loanAmount, lvr, res, result, formattedResult;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$propertyPrice = _ref2.propertyPrice, propertyPrice = _ref2$propertyPrice === void 0 ? 0 : _ref2$propertyPrice, deposit = _ref2.deposit;
            setError(false);
            setResults(null);
            _context.prev = 3;
            api = "".concat(process.env.GATSBY_API_URL, "/lmi/v2/lmi-calculator");
            loanAmount = calculateLoanAmount(deposit, propertyPrice);
            lvr = calculateLvrRate(loanAmount, propertyPrice) || 0;
            _context.next = 9;
            return fetch(api, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                loanAmount: loanAmount,
                lvr: lvr * 100,
                isFirstHomeBuyer: true,
                isInvestment: false,
                isSelfEmployed: false,
                loanPurpose: 'PurchaseOrConstruction',
                properties: [{
                  state: state.value,
                  value: propertyPrice
                }]
              })
            });
          case 9:
            res = _context.sent;
            _context.next = 12;
            return res.json();
          case 12:
            result = _context.sent;
            formattedResult = result.length > 0 ? [result[0].premium, result[(result === null || result === void 0 ? void 0 : result.length) - 1].premium] : undefined; // Reset form state for disabling calculate button
            reset(_objectSpread(_objectSpread({}, DEFAULT_VALUES), {}, {
              propertyPrice: propertyPrice,
              deposit: deposit
            }));
            setResults({
              lvr: lvr,
              lmi: formattedResult,
              state: state.value
            });
            _context.next = 21;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](3);
            setError(true);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 18]]);
    }));
    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/jsxs(Wrapper$1, {
    children: [error && /*#__PURE__*/jsx(StyledAlert, {
      heading: "Something went wrong",
      variant: "error",
      children: "We're working on fixing this issue. Please try again later."
    }), /*#__PURE__*/jsxs(Calculator, {
      onSubmit: handleSubmit(onSubmit),
      children: [calculatorHeading && /*#__PURE__*/jsx(Title, {
        size: 'sm',
        children: calculatorHeading
      }), /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 2,
            sm: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('propertyPriceValue'),
            children: /*#__PURE__*/jsx(StyledHeading$1, {
              size: "xxs",
              children: "The price of the property is"
            })
          }), /*#__PURE__*/jsx(Input, {
            ref: register,
            id: generateId('propertyPriceValue'),
            name: "propertyPrice",
            isFullWidth: true,
            size: "md",
            type: "text",
            onChange: function onChange() {
              return undefined;
            },
            onBlur: propertyPriceHandler.blur,
            onFocus: propertyPriceHandler.focus,
            before: /*#__PURE__*/jsx(InputBefore, {
              children: "$"
            }),
            isError: Boolean(errors.propertyPrice)
          }), errors.propertyPrice && /*#__PURE__*/jsxs(Text, {
            appearance: "error",
            tag: "p",
            variant: "detail2",
            children: [/*#__PURE__*/jsx(Error$1, {
              color: getColour('interaction', 'error')
            }), " ", errors.propertyPrice.message]
          })]
        }), /*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 2,
            sm: 1
          },
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: generateId('depositValue'),
            children: /*#__PURE__*/jsx(StyledHeading$1, {
              size: "xxs",
              children: "My deposit is"
            })
          }), /*#__PURE__*/jsx(Input, {
            ref: register,
            id: generateId('depositValue'),
            isFullWidth: true,
            name: "deposit",
            size: "md",
            type: "text",
            onChange: function onChange() {
              return undefined;
            },
            onBlur: depositHandler.blur,
            onFocus: depositHandler.focus,
            before: /*#__PURE__*/jsx(InputAfter, {
              size: "md",
              children: "$"
            }),
            isError: Boolean(errors.deposit)
          }), errors.deposit && /*#__PURE__*/jsxs(Text, {
            appearance: "error",
            tag: "p",
            variant: "detail2",
            children: [/*#__PURE__*/jsx(Error$1, {
              color: getColour('interaction', 'error')
            }), " ", errors.deposit.message]
          })]
        }), /*#__PURE__*/jsxs(StyledUnit, {
          size: {
            lg: 1 / 2,
            sm: 1 / 2
          },
          children: [/*#__PURE__*/jsx(StyledHeading$1, {
            size: "xxs",
            children: "The property is located in"
          }), /*#__PURE__*/jsx(StyledSelect, {
            isFullWidth: true,
            options: items,
            value: state,
            onChangeItem: function onChangeItem(item) {
              return setState(item);
            }
          })]
        }), /*#__PURE__*/jsx(StyledUnit, {
          size: 1,
          children: /*#__PURE__*/jsx(StyledButtonWrapper, {
            children: /*#__PURE__*/jsx(Button, {
              "data-testid": "calculate-button",
              type: "submit",
              variant: "primary",
              size: "md",
              width: "100%",
              onClick: function onClick() {
                var _window;
                tracking.button.primary('LMI Calculator', {
                  text: 'Calculate',
                  anonymousId: ((_window = window) === null || _window === void 0 ? void 0 : _window.localStorage.getItem('ajs_anonymous_id')) || undefined
                });
              }
              // Form needs to be valid AND values need to be changed from last submit
              ,
              isDisabled: !disableCalculateButton,
              children: "Calculate"
            })
          })
        })]
      })]
    }), results && /*#__PURE__*/jsx(ResultsPanel, _objectSpread(_objectSpread({}, results), {}, {
      buttonLink: embedMarketingTrackingIntoURL(buttonLink),
      buttonText: buttonText,
      ref: resultElement,
      resultBody: resultBody,
      resultHeading: resultHeading
    })), results && /*#__PURE__*/jsx(ResultsWrapper, {
      children: /*#__PURE__*/jsx(Summary, {
        children: disclaimer
      })
    })]
  });
};

export { LmiCalculator as default };
